<template>
  <div class="contacUs">
    <div class="borser">
      <div @click="showContent" class="whitie_img">
        <img src="@/assets/home/black_phone.png" alt="" />
      </div>
      <div @click="showContent" class="black_img">
        <img src="@/assets/home/white_phone.png" alt="" />
        <div>联系我们</div>
      </div>
    </div>
    <el-dialog
      custom-class="grade_dialog"
      :visible.sync="dialogVisible"
      top="20vh"
    >
      <div class="dialog_header">
        <div class="logo">
          <img src="../assets/activity/contacLogo.png" alt="" />
        </div>
        <div class="title">联系我们</div>
      </div>
      <el-form
        :model="submitForm"
        :rules="submitRules"
        ref="submitForm"
        class="contactForm"
      >
        <el-form-item prop="theName">
          <el-input
            placeholder="请输入您的姓名"
            clearable
            v-model="submitForm.theName"
            style="width: 100%;"
          >
          </el-input>
          <img src="@/assets/Example/name.png" alt="" class="posiImg" />
        </el-form-item>
        <el-form-item prop="phone">
          <el-input
            placeholder="请输入您的电话"
            style="width: 100%;"
            clearable
            v-model="submitForm.phone"
          >
          </el-input>
          <img src="@/assets/Example/mobile.png" alt="" class="posiImg" />
        </el-form-item>
        <el-form-item prop="companyName">
          <el-input
            placeholder="请输入您的公司名称"
            clearable
            v-model="submitForm.companyName"
            style="width: 100%;"
          >
          </el-input>
          <img src="@/assets/Example/company.png" alt="" class="posiImg" />
        </el-form-item>
        <el-form-item prop="duties">
          <el-input
            placeholder="请输入您的职务"
            style="width: 100%;"
            clearable
            v-model="submitForm.duties"
          >
          </el-input>
          <img src="@/assets/Example/job.png" alt="" class="posiImg" />
        </el-form-item>
        <el-form-item prop="theContent">
          <el-input
            placeholder="请输入您想沟通的内容"
            clearable
            v-model="submitForm.theContent"
            style="width: 100%;"
            type="textarea"
            :rows="3"
            class="theContent"
          >
          </el-input>
          <img src="@/assets/Example/content.png" alt="" class="posiImg2" />
        </el-form-item>
        <el-button
          type="primary"
          class="submitStyle"
          @click="submit('submitForm')"
          >提 交</el-button
        >
      </el-form>
    </el-dialog>
    <el-dialog
      :show-close="false"
      custom-class="complete_dialog"
      :visible.sync="completeSubmitDialog"
      top="20vh"
    >
      <div class="complete_show">
        <img src="../assets/activity/Maskgroup.png" alt="" />
        <div>您已提交成功！</div>
        <el-button @click="closeDialog" type="primary" class="submitStyle"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import VueQr from "vue-qr";
import { contactUs } from "@/api/Example/Example";
export default {
  components: {},
  data() {
    return {
      active: false,
      dialogVisible: false,
      completeSubmitDialog: false,
      submitForm: {
        companyName: "",
        duties: "",
        phone: "",
        theContent: "",
        theName: "",
      },
      submitRules: {
        theName: [
          { required: true, message: "请输入您的姓名", trigger: "bulr" },
        ],
        phone: [{ required: true, message: "请输入您的电话", trigger: "bulr" }],
        theContent: [
          { required: true, message: "请输入您想沟通的内容", trigger: "bulr" },
        ],
      },
    };
  },
  computed: {},
  watch: {
    dialogVisible: function(newVal, oldVal) {
      console.log(oldVal);
      if (!newVal) {
        this.$refs.submitForm.resetFields();
        this.submitForm = {
          companyName: "",
          duties: "",
          phone: "",
          theContent: "",
          theName: "",
        };
      }
    },
  },
  methods: {
    mouseimg() {
      this.active = true;
    },
    downimg() {
      this.active = false;
    },
    showContent() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.completeSubmitDialog = false;
    },
    submit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let postData = that.$common.copyObj(that.submitForm);
          contactUs(postData)
            .then(function(response) {
              if (response.code == 1) {
                console.log("1111");
                // that.submitForm = {};
                that.dialogVisible = false;
                that.completeSubmitDialog = true;
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          that.$message.error("请检查填写信息");
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";
</style>
<style lang="less">
@media screen and (min-width: 1024px) {
  .contacUs {
    position: fixed;
    z-index: 9999;
    bottom: 25%;
    right: 0;

    .borser {
      width: 0.7813rem;
      height: 0.2604rem;
      overflow: hidden;
      margin-right: 0.1042rem;
      position: relative;
      .whitie_img {
        transition: all 3s;
        position: absolute;
        right: 0;
        width: 0.2604rem;
        height: 0.2604rem;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 0.1563rem;
          height: 0.1563rem;
        }
      }
      .black_img {
        transition: all 0.3s;
        right: -100%;
        position: absolute;
        width: 0.7708rem;
        height: 0.2604rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%), #d9d9d9;
        border-radius: 25px 25px 25px 25px;
        padding: 0 0.0521rem;
        box-sizing: border-box;
        cursor: pointer;
        img {
          width: 0.1563rem;
          height: 0.1563rem;
        }
        div {
          font-family: Source-Regular;
          font-weight: 500;
          font-size: 0.0938rem;
          color: #ffffff;
          text-align: center;
        }
      }
      .whitie_img:hover + .black_img {
        right: 0;
      }
      .whitie_img:hover {
        opacity: 0;
      }
      .black_img:hover + .whitie_img {
        opacity: 1;
      }
      .black_img:hover {
        right: 0;
      }
    }

    .grade_dialog {
      width: 55%;
      border-radius: 10px 10px 10px 10px;

      .el-icon-close:before {
        font-size: 20px;
        font-weight: bold;
      }

      .el-dialog__header {
        padding: 0;
      }

      .dialog_header {
        display: flex;
        justify-content: center;
        align-items: center;

        .logo {
          img {
            width: 0.4323rem;
            height: 0.2813rem;
          }
        }

        .title {
          font-size: 0.125rem;
          font-weight: 500;
          font-family: Source-Medium; //粗字体
          color: #000000;
          line-height: 0.2813rem;
          margin-left: 0.1042rem;
        }
      }

      .contactForm {
        width: 2.7083rem;
        margin: 0 auto;
        margin-top: 0.1563rem;
        position: relative;

        .posiImg {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 9px;
          left: 8px;
        }

        .posiImg2 {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 8px;
          left: 8px;
        }

        .theContent {
          font-size: 0.0833rem;
          color: #606266;
          line-height: 0.099rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .submitStyle {
          width: 100%;
          background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          border-radius: 0.0313rem;
          font-family: Source Han Sans SC, Source Han Sans SC;
          font-weight: 400;
          font-size: 0.0833rem;
          color: #ffffff;
          line-height: 0.099rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: 0.1354rem auto;
          display: block;
        }
      }

      .el-input__inner {
        text-indent: 23px;
        padding: 0 -17px;
      }

      .el-textarea .el-textarea__inner {
        width: calc(100% - 35px);
        padding: 6px 17px;
        box-sizing: content-box;
        resize: none;
        font-family: Source-Regular;
        font-weight: 400;
        text-indent: 23px;
        font-size: 14px;
      }

      .el-textarea input::-moz-input-placeholder {
        color: #9c9ea2;
      }

      .el-textarea__inner::-webkit-input-placeholder {
        color: #9c9ea2;
      }

      .el-input__inner input::-moz-input-placeholder {
        color: #9c9ea2;
      }

      .el-input__inner::-webkit-input-placeholder {
        color: #9c9ea2;
      }
    }

    .complete_dialog {
      width: 20%;
      border-radius: 16px 16px 16px 16px;

      .el-dialog__header {
        padding: 0;
      }

      .complete_show {
        text-align: center;

        img {
          width: 0.4792rem;
          height: 0.4792rem;
          margin: 0 auto;
        }

        div {
          font-size: 0.0938rem;
          font-weight: 500;
          font-family: Source-Medium; //粗字体
          color: #333333;
          line-height: 0.1458rem;
        }

        .submitStyle {
          width: 100%;
          background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          border-radius: 0.0313rem;
          font-family: Source Han Sans SC, Source Han Sans SC;
          font-weight: 400;
          font-size: 0.0833rem;
          color: #ffffff;
          line-height: 0.099rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: 0.1354rem auto;
          display: block;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .contacUs {
    position: fixed;
    z-index: 9999;
    bottom: 25%;
    right: 5px;

    .borser {
      .whitie_img {
        transition: all 0.3s;
        position: absolute;
        right: 0;
        width: 1.0667rem;
        height: 1.0667rem;
        border-radius: 50%;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: .5333rem;
          height: .5333rem;
        }
      }
      .black_img {
        display: none;
      }
    }

    .grade_dialog {
      width: 90%;
      border-radius: 10px 10px 10px 10px;

      .el-icon-close:before {
        font-size: 20px;
        font-weight: bold;
      }

      .el-dialog__header {
        padding: 0;
      }

      .dialog_header {
        display: flex;
        justify-content: center;
        align-items: center;

        .logo {
          img {
            width: 1.28rem;
            height: 0.8267rem;
          }
        }

        .title {
          font-size: 0.4267rem;
          font-weight: 500;
          font-family: Source-Medium; //粗字体
          color: #000000;
          line-height: 0.8267rem;
          margin-left: 5px;
        }
      }

      .contactForm {
        width: 7.1733rem;
        margin: 0 auto;
        margin-top: 0.56rem;
        position: relative;

        .posiImg {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 9px;
          left: 8px;
        }

        .posiImg2 {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 8px;
          left: 8px;
        }

        .theContent {
          font-size: 0.0833rem;
          color: #606266;
          line-height: 0.099rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .submitStyle {
          width: 100%;
          background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          border-radius: 0.0313rem;
          font-family: Source Han Sans SC, Source Han Sans SC;
          font-weight: 400;
          font-size: 0.3733rem;
          color: #ffffff;
          line-height: 0.4267rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: 0.2667rem auto;
          display: block;
        }
      }

      .el-input__inner {
        text-indent: 23px;
        padding: 0 -17px;
      }

      .el-textarea .el-textarea__inner {
        width: calc(100% - 35px);
        padding: 6px 17px;
        box-sizing: content-box;
        resize: none;
        font-family: Source-Regular;
        font-weight: 400;
        text-indent: 23px;
        font-size: 14px;
      }

      .el-textarea input::-moz-input-placeholder {
        color: #9c9ea2;
      }

      .el-textarea__inner::-webkit-input-placeholder {
        color: #9c9ea2;
      }

      .el-input__inner input::-moz-input-placeholder {
        color: #9c9ea2;
      }

      .el-input__inner::-webkit-input-placeholder {
        color: #9c9ea2;
      }
    }

    .complete_dialog {
      width: 70%;
      border-radius: 16px 16px 16px 16px;

      .el-dialog__header {
        padding: 0;
      }

      .complete_show {
        text-align: center;

        img {
          width: 2.1333rem;
          height: 2.1333rem;
          margin: 0 auto;
        }

        div {
          font-size: 0.3733rem;
          font-weight: 500;
          font-family: Source-Medium; //粗字体
          color: #333333;
          line-height: 0.5867rem;
        }

        .submitStyle {
          width: 100%;
          background: linear-gradient(90deg, #68a4ff 0%, #166df0 100%);
          border-radius: 0.1333rem;
          font-family: Source Han Sans SC, Source Han Sans SC;
          font-weight: 400;
          font-size: 0.3733rem;
          color: #ffffff;
          line-height: 0.6133rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: 0.2667rem auto;
          display: block;
        }
      }
    }
  }
}
</style>
